/*
 * Days the warehouse does NOT dispatch, on top of every Saturday and Sunday.
 * Read by assets/nz-shipping.js (PDP dispatch message + product-card stock status).
 *
 * - Format 'YYYY-MM-DD', any order. Anything goes: public holidays, a Christmas
 *   shutdown, a stocktake day.
 * - List the day the warehouse is actually shut. When a holiday lands on a
 *   weekend, list the Mondayised day (Anzac Day 2026 is Sat 25 Apr, so list
 *   Mon 27 Apr).
 * - Nationwide holidays, plus Auckland Anniversary Day (the warehouse is in
 *   Auckland and closes for it). Other regions' anniversary days are left out on
 *   purpose. They are what broke the old date.nager.at feed.
 * - Filled in through 2030. Always keep next year listed. If the current year has no dates,
 *   nz-shipping.js logs a console warning and only skips weekends.
 * - Checked by scripts/check-nz-closed-dates.mjs (on every PR that touches this
 *   file, and monthly): bad format, duplicates, weekend dates (forgot to
 *   Mondayise) and nationwide or Auckland holidays missing for this year or next
 *   all fail it.
 */
window.FoxTheme = window.FoxTheme || {};
window.FoxTheme.nzClosedDates = [
  // 2026
  '2026-01-01', // New Year's Day
  '2026-01-02', // Day after New Year's Day
  '2026-01-26', // Auckland Anniversary Day (warehouse region)
  '2026-02-06', // Waitangi Day
  '2026-04-03', // Good Friday
  '2026-04-06', // Easter Monday
  '2026-04-27', // Anzac Day (Mondayised)
  '2026-06-01', // King's Birthday
  '2026-07-10', // Matariki
  '2026-10-26', // Labour Day
  '2026-12-25', // Christmas Day
  '2026-12-28', // Boxing Day (Mondayised)

  // 2027
  '2027-01-01', // New Year's Day
  '2027-01-04', // Day after New Year's Day (Mondayised)
  '2027-02-01', // Auckland Anniversary Day (warehouse region)
  '2027-02-08', // Waitangi Day (Mondayised)
  '2027-03-26', // Good Friday
  '2027-03-29', // Easter Monday
  '2027-04-26', // Anzac Day (Mondayised)
  '2027-06-07', // King's Birthday
  '2027-06-25', // Matariki
  '2027-10-25', // Labour Day
  '2027-12-27', // Christmas Day (Mondayised)
  '2027-12-28', // Boxing Day (moved to Tuesday)

  // 2028
  '2028-01-03', // New Year's Day (Mondayised)
  '2028-01-04', // Day after New Year's Day (moved to Tuesday)
  '2028-01-31', // Auckland Anniversary Day (warehouse region)
  '2028-02-07', // Waitangi Day (Mondayised)
  '2028-04-14', // Good Friday
  '2028-04-17', // Easter Monday
  '2028-04-25', // Anzac Day
  '2028-06-05', // King's Birthday
  '2028-07-14', // Matariki
  '2028-10-23', // Labour Day
  '2028-12-25', // Christmas Day
  '2028-12-26', // Boxing Day

  // 2029
  '2029-01-01', // New Year's Day
  '2029-01-02', // Day after New Year's Day
  '2029-01-29', // Auckland Anniversary Day (warehouse region)
  '2029-02-06', // Waitangi Day
  '2029-03-30', // Good Friday
  '2029-04-02', // Easter Monday
  '2029-04-25', // Anzac Day
  '2029-06-04', // King's Birthday
  '2029-07-06', // Matariki
  '2029-10-22', // Labour Day
  '2029-12-25', // Christmas Day
  '2029-12-26', // Boxing Day

  // 2030
  '2030-01-01', // New Year's Day
  '2030-01-02', // Day after New Year's Day
  '2030-01-28', // Auckland Anniversary Day (warehouse region)
  '2030-02-06', // Waitangi Day
  '2030-04-19', // Good Friday
  '2030-04-22', // Easter Monday
  '2030-04-25', // Anzac Day
  '2030-06-03', // King's Birthday
  '2030-06-21', // Matariki
  '2030-10-28', // Labour Day
  '2030-12-25', // Christmas Day
  '2030-12-26', // Boxing Day
];
